import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
    name: 'customCurrency',
    pure: true,
    standalone: false
})
export class CustomCurrencyPipe implements PipeTransform {

    constructor(private currencyPipe: CurrencyPipe) {}

    transform(
        value: number,
        currencyCode: string,
        display: 'symbol' | 'symbol-narrow' | string = 'symbol',
        digits: string = '1.0-0',
        locale: string = 'en'
    ) {
        if (currencyCode === 'AED' && display.includes('symbol')) {
            locale = 'ar';
        }

        return this.currencyPipe.transform(
            value,
            currencyCode,
            display,
            digits,
            locale
        );
    }
}
